<template>
  <b-col md="12" class="mb-3">
    <b-card class="formCardDash">
      <div class="card-header">
        <h6 class="card-title mb-0">Console Booking Details</h6>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-sm">
            <thead>
              <tr>
                <th>Booking No</th>
                <th>Booking Type</th>
                <th>Booking For</th>
                <th>Contract No</th>
                <th>Client Name</th>
                <th>Branch</th>
                <th>POR</th>
                <th>POL</th>
                <th>POD</th>
                <th>Validity Start</th>
                <th>Validity End</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(booking, index) in consoleBookingData" :key="index">
                <td>{{ booking.Bookingno || booking.bookingNo || 'N/A' }}</td>
                <td>{{ booking.BookingType || booking.bookingType || booking.ActiveStatus || 'N/A' }}</td>
                <td>{{ booking.BookingFor || booking.bookingFor || booking.FromBooingResponse || 'N/A' }}</td>
                <td>{{ booking.Contractno || booking.contractNo || 'N/A' }}</td>
                <td>{{ booking.ClientName || booking.clientName || 'N/A' }}</td>
                <td>{{ booking.Branch || booking.branchName || 'N/A' }}</td>
                <td>{{ booking.Por || booking.por || 'N/A' }}</td>
                <td>{{ booking.Pol || booking.pol || 'N/A' }}</td>
                <td>{{ booking.Pod || booking.pod || 'N/A' }}</td>
                <td>{{ formatDate(booking.ValidityStart || booking.validityStart) }}</td>
                <td>{{ formatDate(booking.ValidityEnd || booking.validityEnd) }}</td>
                <td>
                  <b-badge
                    :variant="
                      booking.BookingStatus === 'Released'
                        ? 'success'
                        : booking.BookingStatus === 'Un-Released'
                        ? 'warning'
                        : 'secondary'
                    "
                    >{{ booking.BookingStatus || booking.status || 'N/A' }}</b-badge
                  >
                </td>
              </tr>
              <tr v-if="consoleBookingData.length === 0">
                <td colspan="12" class="text-center text-muted">
                  No data available
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
  </b-col>
</template>

<script>
import moment from "moment";

export default {
  name: "ConsoleBookingSection",
  props: {
    consoleBookingData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("DD-MM-YYYY");
    },
  },
};
</script>

<style scoped>
.formCardDash {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// ConsoleBookingSection.vue?6d933e0a